import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
	ActionSheetController,
	App,
	NavController,
	Platform
} from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { TapticEngine } from '@ionic-native/taptic-engine';

import { EventTabsPage } from '../../pages/event/details/event-tabs/event-tabs';
import {
	EventDetailsModel,
	EventProvider,
	MyEventListModel
} from '../../providers/event/event';
import { LoaderProvider } from '../../providers/loader/loader';
import { AppDetectorProvider } from '../../providers/detector/detector';

/**
 * Generated class for the MyEventListItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
	selector: 'my-event-list-item',
	templateUrl: 'my-event-list-item.html'
})
export class MyEventListItemComponent {
	@Input('event')
	event: MyEventListModel;
	@Output()
	removed: EventEmitter<number>;

	validDate: Date;
	constructor(
		public eventService: EventProvider,
		private actionSCtrl: ActionSheetController,
		private loadingCtrl: LoaderProvider,
		public appDetector: AppDetectorProvider,
		private app: App,
		public translate: TranslateService,
		private taptic: TapticEngine,
		private platform: Platform,
		private navCtrl: NavController
	) {
		this.removed = new EventEmitter<number>();
	}

	ngOnChanges() {
		let splited: number[] = [];
		if(this.event.dateFormatted){
			this.event.dateFormatted.split('.').forEach(item => {
				splited.push(parseInt(item));
			});
			this.validDate = new Date(splited[2], splited[1], splited[0]);
		}
		if(this.event.date){
			this.validDate = new Date(this.event.date);
		}
	}

	removeEvent() {
		this.eventService.removeMyEvent(this.event.id).then((succ: boolean) => {
			if (succ) {
				this.removed.emit(this.event.id);
			}
		});
	}

	openEventDetails() {
		let loader = this.loadingCtrl.create({
			content: this.translate.instant('GLOBAL_LOADING')
		});
		loader.present();
		this.eventService
			.getEventDetails(this.event.id)
			.then((event: EventDetailsModel) => {
				this.navCtrl.push(EventTabsPage, { event: event })
				loader.dismiss();
			});
	}

	showSheet() {
		let sheet = this.actionSCtrl.create({
			title: this.translate.instant('GLOBAL_OPTIONS'),
			buttons: [
				{
					text: this.translate.instant('GLOBAL_DELETE'),
					role: 'destructive',
					handler: () => {
						this.removeEvent();
					}
				},
				{
					text: this.translate.instant('GLOBAL_CANCEL'),
					role: 'cancel'
				}
			]
		});
		if (window['TapticEngine'] && this.platform.is('ios')) {
			this.taptic.selection();
		}
		sheet.present();
	}

	onDelete(ev) {
		this.eventService.removeFavEvent(ev, ev.id).then(() => {
			this.updateEventList(ev.id);
		})
	}

	updateEventList(id) {
		this.removed.emit(id);
	}
}



// WEBPACK FOOTER //
// /src/components/my-event-list-item/my-event-list-item.ts